import { fromJS, Map } from 'immutable';
import { SET_CARDS } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  cardsById: {},
  cardsLoaded: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CARDS:
      return state.set('cardsById', Map(action.payload.get('cards').map(card => [card.get('id'), card])))
        .set('cardsLoaded', true);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
